import { Box } from '@spark-web/box';
import { Divider } from '@spark-web/divider';
import { Heading } from '@spark-web/heading';
import { ContentDialog } from '@spark-web/modal-dialog';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import DOMPurify from 'dompurify';

import PromoTag from '~/components/vendors/promo-tag';
import { useModal } from '~/hooks/useModal';
import { usePromotionContents } from '~/hooks/usePromotionContents';

type PromotionInformationProps = {
  code?: string;
  channel: string | null;
};

export const PromotionInformation = ({ code, channel }: PromotionInformationProps) => {
  const { close, onCloseAutoFocus, isOpen } = useModal('promotion-information');

  const { data } = usePromotionContents({ promotionCodes: code ? [code] : [], channel });

  if (!code) {
    return null;
  }

  return (
    <ContentDialog
      title="Battery offer"
      showCloseButton
      isOpen={isOpen}
      onToggle={close}
      onCloseAutoFocus={onCloseAutoFocus}
    >
      <Box flexDirection="column">
        <Box display="inline-block" paddingBottom="large">
          <PromoTag theme="pantheon">
            <Text size="xsmall">Battery offer</Text>
          </PromoTag>
        </Box>
        <Stack gap="medium">
          <Heading as="h3" level="2">
            {data?.summary}
          </Heading>
          {data?.details?.html ? (
            <Text dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.details.html) }} />
          ) : null}
          <Divider />
          {data?.disclaimer?.html ? (
            <Text dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.disclaimer.html) }} />
          ) : null}
        </Stack>
      </Box>
    </ContentDialog>
  );
};
